const generateKvkkText = ({ name, company, email, date }) => `
6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU (KVKK) AYDINLATMA METNİ VE AÇIK RIZA BEYANI

Yürürlük Tarihi: ${date}

Taraflar:
- Veri Sorumlusu: IDEATRUM YAPAY ZEKA MÜHENDİSLİK ARGE YAZILIM VE DANIŞMANLIK HİZMETLERİ TİCARET LİMİTED ŞİRKETİ ("Veri Sorumlusu")
- İlgili Kişi (Kullanıcı): ${name} (${email}) - ${company}

1. AMAÇ VE KAPSAM
Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, ${name} tarafından paylaşılan kişisel verilerin hangi amaçlarla işleneceğini, saklanacağını, aktarılacağını ve ilgili hakları bilgilendirmek amacıyla hazırlanmıştır.

2. İŞLENEN KİŞİSEL VERİLER
- Ad Soyad: ${name}
- E-posta Adresi: ${email}
- Şirket Adı: ${company}
- Kullanım kayıtları, giriş/çıkış zamanları, cihaz bilgileri
- Proje içerikleri ve ilgili metinler

3. VERİ İŞLEME AMAÇLARI
Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
- Hizmetin sunulması, yönetilmesi ve geliştirilmesi
- Kullanıcı hesabınızın doğrulanması ve güvenliğinin sağlanması
- Teknik destek ve müşteri hizmetleri
- Yasal yükümlülüklerin yerine getirilmesi
- Anonimleştirilmiş olarak yapay zekâ eğitimleri ve performans iyileştirmeleri

4. VERİLERİN AKTARILMASI
Kişisel verileriniz yalnızca aşağıdaki durumlarda üçüncü kişilerle paylaşılabilir:
- Yasal zorunluluklar gereği yetkili kurum ve kuruluşlara
- Teknik hizmet sağlayıcılarına (barındırma, güvenlik, bakım vb.)
- Araştırma, geliştirme ve analiz amaçlı olarak anonimleştirilmiş şekilde

5. SAKLAMA SÜRESİ
Kişisel verileriniz, hesabınız aktif olduğu sürece ve ilgili mevzuatın öngördüğü azami süre boyunca saklanır. Hesabın kapatılması talebiniz üzerine, verileriniz silinir veya anonimleştirilir.

6. VERİ GÜVENLİĞİ
Verilerinizin güvenliği için alınan önlemler:
- SSL/TLS ile güvenli veri iletimi
- Kimlik doğrulama ve yetkilendirme kontrolleri
- Düzenli güvenlik testleri ve yedekleme

7. HAKLARINIZ
KVKK uyarınca aşağıdaki haklara sahipsiniz:
- Kişisel verilerinizin işlenip işlenmediğini öğrenme
- Verilere erişim ve bunların kopyasını talep etme
- Yanlış veya eksik verilerin düzeltilmesini isteme
- Verilerinizin silinmesini veya yok edilmesini isteme
- İşleme faaliyetinin sınırlandırılmasını talep etme
- Açık rızanızı geri çekme

Haklarınızı kullanmak için Veri Sorumlusu'na yazılı olarak veya e-posta yoluyla başvurabilirsiniz.

8. AÇIK RIZA BEYANI
Bu metni onaylayarak, yukarıda belirtilen kapsamda kişisel verilerimin işlenmesine, yurt içinde ve yurt dışında saklanmasına ve belirtilen üçüncü kişilerle paylaşılmasına açık rıza gösterdiğimi kabul ediyorum.

---

KULLANICI ONAY BEYANI:

Ben, ${name} (${email}) – ${company}, "6698 Sayılı KVKK Aydınlatma Metni ve Açık Rıza Beyanı"nın tamamını okuduğumu, anladığımı ve tüm şartları kabul ettiğimi beyan ederim.

Onay Tarihi: ${date}
`;

export default generateKvkkText;
